import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_SEARCH_WORD_PAGE_NAME } from '../../../constants/service/app/recommendSearchWordConstants';
import RecommendSearchWordListContainer from '../../../containers/recommend/searchWord/RecommendSearchWordListContainer';

const RecommendSearchWordList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_SEARCH_WORD_PAGE_NAME.RECOMMEND_SEARCH_WORD_LIST}>
      <RecommendSearchWordListContainer />
    </PageTemplate>
  );
};

export default RecommendSearchWordList;
